import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=1312556d&scoped=true"
import script from "./AddOns.vue?vue&type=script&lang=js"
export * from "./AddOns.vue?vue&type=script&lang=js"
import style0 from "./AddOns.vue?vue&type=style&index=0&id=1312556d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1312556d",
  null
  
)

export default component.exports